/**
 * next/link shim — prod leaves that import `next/link` get react-router navigation.
 *
 * Internal paths ("/clients") use react-router's <Link> so navigation is
 * client-side — this preserves the demo's in-memory state (a full-page <a> reload
 * would re-seed and forget added clients/sessions). External/mailto/hash links
 * fall back to a plain <a>. Next-only props are accepted + ignored.
 */
import type { AnchorHTMLAttributes, ReactNode } from "react";
import { Link as RouterLink } from "react-router-dom";

interface LinkProps extends Omit<AnchorHTMLAttributes<HTMLAnchorElement>, "href"> {
  href: string;
  children?: ReactNode;
  prefetch?: boolean;
  replace?: boolean;
  scroll?: boolean;
}

export default function Link({ href, children, prefetch: _p, replace, scroll: _s, ...rest }: LinkProps) {
  const isInternal = href.startsWith("/") && !href.startsWith("//");
  if (isInternal) {
    return (
      <RouterLink to={href} replace={replace} {...rest}>
        {children}
      </RouterLink>
    );
  }
  return (
    <a href={href} {...rest}>
      {children}
    </a>
  );
}
